"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Checkbox = function Checkbox() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M339.9,301.9v99.2c0,6.8-5.5,12.3-12.3,12.3H113.8c-6.8,0-12.3-5.5-12.3-12.3V187.4c0-6.8,5.5-12.3,12.3-12.3h145.9 l48.8-47.7H113.8c-33.1,0-60,26.9-60,60v213.7c0,33.1,26.9,60,60,60h213.7c33.1,0,60-26.9,60-60V234.6L339.9,301.9z"
  }), _react["default"].createElement("path", {
    d: "M456.5,71.8L241.6,375.4c-2.4,3.5-6.5,5.5-10.8,5.5c-0.1,0-0.3,0-0.3,0c-4.4-0.2-8.5-2.4-10.8-6.1l-88.3-139.4 c-3.3-5.2-2.5-11.9,1.8-16.3c4.4-4.4,11.2-5.1,16.3-1.8l73.5,46L436.5,54.9c4.9-4.8,12.6-5,17.8-0.6 C459.5,58.6,460.5,66.3,456.5,71.8z"
  }));
};

Checkbox.displayName = 'Checkbox';
var _default = Checkbox;
exports["default"] = _default;
Checkbox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Checkbox"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Checkbox.js"] = {
    name: "Checkbox",
    docgenInfo: Checkbox.__docgenInfo,
    path: "src/Checkbox.js"
  };
}